<template>
    <div>
        <breadcrumbs>
            <inertia-link href="/scrapers">Scrapers</inertia-link>
            <i class="fad fa-chevron-right"></i>
            {{ scraper.name }}
        </breadcrumbs>

        <div class="">
            <h1 class="text-5xl text-teal-800">
                Scrapers <i class="fad fa-chevron-double-right text-4xl"></i>
                {{ scraper.name }}
            </h1>
        </div>

        <div class="mt-6">
            <div class="flex items-center justify-between">
                <h2 class="text-2xl">Latest scraper runs</h2>
                
                <!-- <div>
                    <inertia-link
                        :href="`/scrapers/${scraper.id}/scrape`"
                        class="group bg-white px-3 py-2 rounded text-teal-800 hover:text-teal-200 hover:bg-teal-800"
                        @click="scrapeSite"
                        preserve-scroll
                        preserve-state
                    >
                        <i class="fad mr-1 text-teal-600 group-hover:text-teal-200" :class="loading == 'runScraper' ? 'fa-spinner fa-pulse' : 'fa-project-diagram'"></i>Scrape Site
                    </inertia-link>
                </div> -->
            </div>

            <scraper-runs-table :scraper-runs="scraperRuns" class="mt-3"></scraper-runs-table>
        </div>

        <div class="mt-6">
            <scraper-entrypoints-table :scraper="scraper" :entrypoints="entrypoints" class="mt-3"></scraper-entrypoints-table>
        </div>

        <!-- <div class="mt-6">
            <h2 class="text-2xl">Scraper pages</h2>
            <scraper-pages-table :scraper="scraper" :pages="pages" :filters="filters" class="mt-3"></scraper-pages-table>
        </div> -->
    </div>
</template>

<script>
import Layout from "@/admin/Shared/Layout";
import Breadcrumbs from "@/admin/Shared/Breadcrumbs";
import ScraperPagesTable from "@/admin/Components/Scrapers/ScraperPagesTable";
import ScraperRunsTable from "@/admin/Components/Scrapers/ScraperRunsTable";
import ScraperEntrypointsTable from "@/admin/Components/Scrapers/ScraperEntrypointsTable";
import Helpers from "@/admin/Mixins/GeneralHelpers.js";
import AutoReload from "@/admin/Shared/AutoReload";

export default {
    layout: Layout,
    mixins: [Helpers],
    components: {
        ScraperPagesTable,
        ScraperEntrypointsTable,
        ScraperRunsTable,
        Breadcrumbs,
        AutoReload
    },

    metaInfo() {
        return {
            title: this.scraper.name + " - Scrapers"
        };
    },

    props: {
        message: String,
        scraper: Object,
        scraperRuns: Array,
        entrypoints: Array,
        filters: Object,
        pages: Object
    },

    data() {
        return {};
    },

    methods: {
        scrapeSite() {
            this.setTempLoading("runScraper");
            this.$eventHub.$emit("set-reloading", true);
        }
    },

    mounted() {
        // if(this.scraper.runs.length && this.scraper.runs[0].jobs_remaining){
        //     this.toggleReload()
        // }
    }
};
</script>
